import { createStore } from 'vuex'

import actions from './actions'
import getters from './getters'
import bottleBot, { createBotModule } from './modules/bottleBot'
import mutations from './mutations'
import { createInitialState } from './state'

const ecommerceBot = createBotModule({ platform: 'ecommerce' })

export const objectRefreshed = mutations.objectRefreshed
delete mutations.objectRefreshed

export default createStore({
  state: createInitialState(),
  mutations,
  getters,
  actions,
  modules: { bottleBot, ecommerceBot }
})
